require
.config({
  paths: {
    requirejs: 'js/requirejs/2.1.20/require',
    text: 'js/requirejs-text/2.0.14/text',
    ccl: 'js/requirejs-ccl/0.1/index',
    async: 'js/requirejs-plugins/1.0.3/src/async',
    font: 'js/requirejs-plugins/1.0.3/src/font',
    image: 'js/requirejs-plugins/1.0.3/src/image',
    json: 'js/requirejs-plugins/1.0.3/src/json',
    noext: 'js/requirejs-plugins/1.0.3/src/noext',
    mdown: 'js/requirejs-plugins/1.0.3/src/mdown',
    propertyParser: 'js/requirejs-plugins/1.0.3/src/propertyParser',
    markdownConverter: 'js/requirejs-plugins/1.0.3/lib/Markdown.Converter'
  },
  bundles: {
    'requirejs-bundle': [
      'requirejs',
      'text',
      'ccl',
      'async',
      'font',
      'image',
      'json',
      'noext',
      'mdown',
      'propertyParser',
      'markdownConverter'
    ]
  }
});

require([
  'requirejs',
  'text',
  'ccl',
  'async',
  'font',
  'image',
  'json',
  'noext',
  'mdown',
  'propertyParser',
  'markdownConverter'
]);

define("requirejs-bundle", function(){});

